import {
    auth,
    db
} from '@/firebase';
import {
    GoogleAuthProvider,
    signInWithPopup,
    signOut,
} from 'firebase/auth';
import {
    USERS
} from '@/config/data/parameters';
import {
    getDoc,
    setDoc,
    doc
} from "firebase/firestore/lite";

async function get_current_user(){
    let user = auth.currentUser;
    return user
}


async function Login_Google() {
    try {
        const provider = new GoogleAuthProvider();
        let result = await signInWithPopup(auth, provider);
        GoogleAuthProvider.credentialFromResult(result);
        const user = result.user;
        let response = {
            name: user.displayName,
            email: user.email,
            id: user.uid,
        }
        const docRef = doc(db, USERS, user.uid);
        let data = await getDoc(docRef);
        if (!data.exists()) {
            setDoc(doc(db, USERS, user.uid), response);
        }
        return {...response, ...data.data()};
    } catch (error) {
        console.log(error);
        return null;
    }
}


async function Logout(){
    try {
        await signOut(auth);
        return true;
    } catch (error) {
        console.error('Error during logout:', error);
        return false;
    }
}

export {
    Login_Google,
    Logout,
    get_current_user
}